<script setup>
import { useBlockSafe } from '@/composables/useBlockSafe';
import Buttons from '@/components/ui/Buttons.vue';
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const {
  id,
  backgroundColor,
  spacingTop,
  spacingBottom,
  buttons,
  hasButtons,
  hasAnyContent,
} = useBlockSafe(props.data);
</script>
<template>
  <section
    v-if="hasAnyContent"
    :id="id"
    class="section"
    :class="[
      backgroundColor ? `bg-${backgroundColor}` : '',
      spacingTop ? `section--top-${spacingTop}` : 'section--top-xl',
      spacingBottom ? `section--bottom-${spacingBottom}` : 'section--bottom-xl',
      backgroundColor === 'black' ? 'white' : '',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div :class="['container', `container--${data?.template}`]">
      <Buttons
        v-if="hasButtons"
        :background-color="backgroundColor"
        :buttons="buttons"
        class="buttons"
        data-aos="fade-up"
        data-aos-easing="ease-out-cubic"
        :buttons-prefix-class="'js-button-buttons'"
      />
    </div>
  </section>
</template>

<style scoped lang="scss">
.buttons {
  justify-content: center;
  margin: 0 auto;
  width: 100%;
}
</style>
